import { render, staticRenderFns } from "./Inventory-page.vue?vue&type=template&id=a2ce77ee&scoped=true&"
import script from "./Inventory-page.vue?vue&type=script&lang=js&"
export * from "./Inventory-page.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a2ce77ee",
  null
  
)

export default component.exports